import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { getAlerts } from '../services/alerts';
import usePagination from './usePagination';

const id = 'alerts';

export const useAlerts = (patient, group, ack_pending, initialPageSize = 9) => {
    const {
        paginationModel,
        setPaginationModel,
        rowsPerPageOptions,
        count,
        currentToken,
        resolveHeader
    } = usePagination(0, initialPageSize);

    const { isPending, isError, data, refetch } = useQuery({
        queryKey: [id, { paginationModel, patient, group, ack_pending }],
        queryFn: () =>
            getAlerts({
                pageLimit: paginationModel.pageSize,
                pageToken: currentToken(paginationModel.page),
                patient,
                group,
                ack_pending
            })
    });

    useEffect(() => {
        if (data) {
            resolveHeader(data.headers, paginationModel.page);
        }
    }, [data, paginationModel.page, resolveHeader]);

    return {
        data: data?.data || [],
        isLoading: isPending,
        error: isError,
        count,
        rowsPerPageOptions,
        paginationModel,
        setPaginationModel,
        refetch
    };
};
